import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

import {getApiSitePrefix} from "../functions/SiteDefaults";

const AccessControl = require("../AccessControl");

const UserRoles = (props) => {
    const { user } = useAuth0();
    const [userRoles, setUserRoles] = useState(null);
    const apiSitePrefix = getApiSitePrefix();

    useEffect(() => {
        const getUserRoles = async () => {
            try {
                const {data} = await axios.get(
                    `${apiSitePrefix}/getuserroles/${user.sub}`
                );

                setUserRoles(data);

            } catch (e) {
                console.log(e.message);
            }
        };

        getUserRoles();
    }, []);


    let displayRoles = "";
    if (userRoles) {
        for (let i = 0; i < userRoles.length; i++) {
            displayRoles = displayRoles + (i > 0 ? ", " : "") + userRoles[i];
        }
    }
    else
        displayRoles = "No user roles defined";
    return ( <pre>{displayRoles}</pre> );
    //return(<div></div>);
};

export default UserRoles;
